<template>
    <v-menu
        v-model="show"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        :close-on-content-click="false"
    >
        <div class="menu-content-container">
            <v-layout align-center class="pa-2">
                <input type="text" v-model="searchKey" ref="input" placeholder="search scenario name">
            </v-layout>
            <div class="item-group-container">
                <v-layout
                    align-center
                    v-for="item in itemList"
                    :key="item.id"
                    @click="selectItem(item)"
                    class="item-container"
                >
                    {{ item.name }}
                </v-layout>
            </div>
        </div>
    </v-menu>
</template>

<script>
import ScenarioService from '@/services/scenario.service'

export default {
    name: 'ScenarioSelectorContextMenu',
    data () {
        return {
            show: false,
            x: 0,
            y: 0,
            searchKey: '',
            itemList: [],
            promise: {
                resolve: null,
                reject: null
            }
        }
    },
    methods: {
        open (node) {
            let el = document.getElementById('fp-' + node.id)
            let viewport = el.getBoundingClientRect()
            this.x = viewport.left
            this.y = viewport.top
            this.show = true
            this.searchScenario()
            setTimeout(() => {
                this.$refs.input.focus()
            }, 100)
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        searchScenario () {
            ScenarioService.CRUD.search({ search: this.searchKey, page: 1, page_size: 5 }).then(
                result => {
                    this.itemList = result.data.data
                },
                this.$appService.handleRequestError()
            )
        },
        selectItem (item) {
            this.search = ''
            this.promise.resolve(item)
            this.show = false
        }
    },
    watch: {
        searchKey: 'searchScenario'
    }
}
</script>

<style scoped lang="scss">
    .menu-content-container {
        background: #fff;
        font-size: 14px;
        border-radius: 10px;

        img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }

        .item-group-container {
            width: 300px;
            height: 300px;
            overflow: auto;
        }
    }

    input {
        border: 1px solid #B2B4C6;
        height: 30px;
        width: 120px;
        border-radius: 50px;
        padding: 5px;
        flex-grow: 1;

        &:focus {
            outline: none;
            border-color: #0052CC;
        }
    }

    .item-container {
        padding: 10px;
        cursor: pointer;
        border-top: 1px solid #EDEDF2;

        &:hover {
            background: #ccc;
        }
    }
</style>
